module.exports = __webpack_public_path__ + "img/pysc.deb1652d.png";